import _pt from "prop-types";
import React from 'react';
import InlineLinkLists from './InlineLinkLists';
import LogosRow from './LogosRow';
import classnames from 'classnames';
import { tWithLanguage } from '../i18n';
export var Footer = function Footer(props) {
  var t = tWithLanguage(props.initialLanguage);
  var classes = classnames('hc-c-footer', props.className);

  if (props.initialLanguage) {
    console.warn("[Deprecated]: Please remove the 'initialLanguage' prop in <Footer> in favor of global language setting. This prop is deprecated and will be removed in a future release.");
  }

  return /*#__PURE__*/React.createElement("footer", {
    className: classes,
    role: "contentinfo"
  }, props.footerTop, /*#__PURE__*/React.createElement(InlineLinkLists, {
    t: t,
    primaryDomain: props.primaryDomain
  }), /*#__PURE__*/React.createElement(LogosRow, {
    t: t
  }));
};
Footer.propTypes = {
  /**
     * Additional classes to be added to the root `<footer>` element.
     */
  className: _pt.string,

  /**
     * The primary, or root domain where the majority of footer links should be
     * hosted.  By default, links render with relative paths, but providing this
     * prop will force all links to render with absolute paths based on the
     * provided string. The string should include the protocol (`http://` or
     * `https://`) and the domain only, with no trailing slash. For example, if
     * the provided string is `https://test.healthcare.gov`, the topics link will
     * render as `https://test.healthcare.gov/topics` instead of just `/topics`.
     * Note that this is only really necessary if your application is hosted on a
     * subdomain, such as `https://localhelp.healthcare.gov`, where relative links
     * would direct the user to the wrong location, e.g. the link to `/topics`
     * would incorrectly direct the user to
     * `https://localhelp.healthcare.gov/topics` when it should direct the user to
     * `https://healthcare.gov/topics`.
     */
  primaryDomain: _pt.string,

  /**
     * Element to be added to display content for top footer section changes
     */
  footerTop: _pt.node
};
export default Footer;